function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlogIcon = function SvgBlogIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M512 467.478C512 492.066 492.066 512 467.478 512H44.522C19.933 512 0 492.066 0 467.478s19.933-44.522 44.522-44.522h422.957c24.587.001 44.521 19.934 44.521 44.522",
    style: {
      fill: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.739 478.609a8.35 8.35 0 0 1-8.348 8.348H72.348a8.349 8.349 0 0 1 0-16.696h89.043a8.347 8.347 0 0 1 8.348 8.348m269.913-8.348H272.696a8.349 8.349 0 0 0 0 16.696h166.957a8.349 8.349 0 0 0-.001-16.696m-204.8 0h-1.113a8.349 8.349 0 0 0 0 16.696h1.113a8.349 8.349 0 0 0 0-16.696m-34.504 0h-1.113a8.349 8.349 0 0 0 0 16.696h1.113a8.349 8.349 0 0 0 0-16.696",
    style: {
      fill: "#777"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.609 155.826v244.87c0 24.588-19.934 44.522-44.522 44.522H77.913c-24.588 0-44.522-19.934-44.522-44.522v-244.87c0-24.588 19.933-44.522 44.522-44.522h356.174c24.588 0 44.522 19.934 44.522 44.522",
    style: {
      fill: "#cccac4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.087 422.957H77.913c-12.295 0-22.261-9.966-22.261-22.261v-244.87c0-12.295 9.966-22.261 22.261-22.261h356.174c12.295 0 22.261 9.966 22.261 22.261v244.87c0 12.294-9.966 22.261-22.261 22.261",
    style: {
      fill: "#f2efe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.261 203.13H105.739c-9.22 0-16.696-7.475-16.696-16.696 0-9.22 7.475-16.696 16.696-16.696h300.522c9.22 0 16.696 7.475 16.696 16.696s-7.476 16.696-16.696 16.696M244.87 244.87c0-9.22-7.475-16.696-16.696-16.696H105.739c-9.22 0-16.696 7.475-16.696 16.696 0 9.22 7.475 16.696 16.696 16.696h122.435c9.221-.001 16.696-7.476 16.696-16.696m178.087 0c0-9.22-7.475-16.696-16.696-16.696H283.826c-9.22 0-16.696 7.475-16.696 16.696 0 9.22 7.475 16.696 16.696 16.696h122.435c9.221-.001 16.696-7.476 16.696-16.696",
    style: {
      fill: "#bfbba3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.261 384H105.739c-9.22 0-16.696-7.475-16.696-16.696v-66.783c0-9.22 7.475-16.696 16.696-16.696h300.522c9.22 0 16.696 7.475 16.696 16.696v66.783c0 9.221-7.475 16.696-16.696 16.696",
    style: {
      fill: "#ffd880"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.688 374.23-2.332 2.332.086.086-19.098 19.098a7.308 7.308 0 0 1-10.334 0l-19.098-19.098.086-.086-2.332-2.332c-6.677-6.677-6.677-17.501 0-24.179s17.501-6.677 24.179 0l2.332 2.332 2.332-2.332c6.677-6.677 17.501-6.677 24.179 0s6.677 17.502 0 24.179",
    style: {
      fill: "#fc8059"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.209 292.36-22.261 29.682c-4.452 5.936-13.357 5.936-17.809 0l-22.261-29.682a11.13 11.13 0 0 1-2.226-6.678V22.261C311.652 9.966 321.618 0 333.913 0h22.261c12.295 0 22.261 9.966 22.261 22.261v263.421a11.14 11.14 0 0 1-2.226 6.678",
    style: {
      fill: "#d6a154"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.087 300.522-16.139 21.518c-4.452 5.936-13.357 5.936-17.809 0L320 300.522z",
    style: {
      fill: "#b26932"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.652 256V22.261C311.652 9.966 321.618 0 333.913 0h22.261c12.295 0 22.261 9.966 22.261 22.261V256z",
    style: {
      fill: "#ffd880"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.043 256V0h11.13c12.295 0 22.261 9.966 22.261 22.261V256z",
    style: {
      fill: "#fcc159"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.435 22.261v22.261h-66.783V22.261C311.652 9.966 321.618 0 333.913 0h22.261c12.295 0 22.261 9.966 22.261 22.261",
    style: {
      fill: "#fc8059"
    }
  }));
};
export default SvgBlogIcon;